(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function clamp(v, lo, hi) { return v < lo ? lo : (v > hi ? hi : v); }

  /* One observer for the page, but the scan is repeatable. It used to run
     once at load against a single querySelectorAll, so a section rendered
     later — a duplicate of this block, or the same one after the theme editor
     re-rendered it — was never observed and simply never animated.

     The flag on each element makes rescanning free: anything already wired is
     skipped, so this can be called as often as needed. */
  var io = null;
  if ('IntersectionObserver' in window && !reduce) {
    io = new IntersectionObserver(function (entries) {
      for (var k = 0; k < entries.length; k++) {
        if (entries[k].isIntersecting) {
          entries[k].target.classList.add('is-inview');
          io.unobserve(entries[k].target);
        }
      }
    }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });
  }

  function scanInview(scope) {
    var els = (scope || document).querySelectorAll('[data-inview]');
    for (var m = 0; m < els.length; m++) {
      if (els[m].dataset.inviewReady) continue;
      els[m].dataset.inviewReady = '1';
      if (io) io.observe(els[m]);
      else els[m].classList.add('is-inview');
    }
  }
  scanInview();

  // the editor tears a section down and rebuilds it on every change, so the
  // fresh markup needs picking up — and this is also what catches a second
  // copy of the block added anywhere else on the page
  document.addEventListener('shopify:section:load', function (e) { scanInview(e.target); });

  // the guard now only stops the scroll-reveal setup below running twice;
  // the in-view scan above is deliberately outside it
  if (window.LuxeShowcase) return;
  window.LuxeShowcase = true;


  var LS = window.LuxeScroll;
  if (!LS) return;

  var revealItems = [];
  Array.prototype.forEach.call(document.querySelectorAll('[data-reveal]'), function (sec) {
    revealItems.push({
      sec: sec,
      isApp: sec.classList.contains('luxe-reveal--app'),
      runway: null,
      pin: null,
      value: 0,
      painted: null
    });
  });

  function runwayOf(rv) {
    if (rv.runway && rv.runway.isConnected) return rv.runway;
    rv.runway = rv.isApp ? rv.sec.querySelector('.mh-story-wrapper') : rv.sec;
    return rv.runway || rv.sec;
  }

  function pinOf(rv) {
    if (rv.pin && rv.pin.isConnected) return rv.pin;
    rv.pin = rv.isApp
      ? rv.sec.querySelector('.mh-story-sticky')
      : rv.sec.querySelector('.luxe-reveal__sticky');
    return rv.pin;
  }

  var adopting = [];
  for (var q = 0; q < revealItems.length; q++) {
    if (revealItems[q].isApp) adopting.push(revealItems[q]);
  }
  if (adopting.length) {
    var adoptTries = 0;
    (function adoptLabels() {
      var pending = 0;
      for (var i = 0; i < adopting.length; i++) {
        var pin = pinOf(adopting[i]);
        if (!pin) { pending++; continue; }
        var label = adopting[i].sec.querySelector('.luxe-reveal__label');
        if (label && !pin.contains(label)) pin.appendChild(label);
      }
      if (pending && adoptTries++ < 900) requestAnimationFrame(adoptLabels);
    })();
  }

  var progressFill = document.querySelector('[data-progress-fill]');
  var progressPainted = null;

  var wantsReveal = !reduce && revealItems.length > 0;
  if (!wantsReveal && !progressFill) return;

  LS.register({
    measure: function (s) {
      if (!wantsReveal) return;

      for (var j = 0; j < revealItems.length; j++) {
        var rv = revealItems[j];
        var rr = runwayOf(rv).getBoundingClientRect();
        var pin = pinOf(rv);
        var pinH = pin ? pin.getBoundingClientRect().height : s.vh;
        var runway = rr.height - pinH;
        var prog = runway > 0 ? clamp(-rr.top / runway, 0, 1) : (rr.top <= 0 ? 1 : 0);
        rv.value = clamp(prog, 0, 1);
      }
    },

    paint: function (s) {
      if (wantsReveal) {
        for (var j = 0; j < revealItems.length; j++) {
          var rv = revealItems[j];
          var v = rv.value.toFixed(3);
          if (v === rv.painted) continue;
          rv.painted = v;
          rv.sec.style.setProperty('--reveal', v);
        }
      }

      if (progressFill) {
        var h = (s.progress * 100).toFixed(2) + '%';
        if (h !== progressPainted) {
          progressPainted = h;
          progressFill.style.height = h;
        }
      }

      return false;
    }
  });
})();
